import './_services-table.scss';
import './_services-table.dark-mode.scss';
import React, { useEffect, useReducer } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useDebounce } from 'use-debounce';

import { Button, Grid } from 'react-bootstrap';
import ServicesHeader from './components/Header';
import ServicesBody from './components/Listing';
import ServiceModals from './components/Modals';
import ServiceLoader from './components/Loader';
import Loader from '../../../components/Loaders/Loader';

import { servicesInit, servicesCheckedSet } from '../../../redux/actions/services';
import {
  serviceTableReducer,
  serviceTableState,
  updateList,
  clearHighlights,
  clearScrolls,
  updateCategoriesList,
  initServiceReducer,
} from './reducer';

const Services = () => {
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();

  const [serviceTable, serviceDispatch] = useReducer(serviceTableReducer, serviceTableState);

  const [serviceTableDebounce] = useDebounce(serviceTable, 350);
  const { search, searchOption, filters, startList, highlightServices, highlightCategories, scrollToCategoryId, scrollToServiceId } = serviceTableDebounce;

  const { isFetching, categories, initServices, servicesChecked, config } = useSelector((state) => state.services);

  useEffect(() => {
    if (location?.state?.clearSelected) {
      dispatch(servicesCheckedSet([]));
    }
    if (!initServices) {
      document.title = 'Services';
      dispatch(servicesInit());
    } else {
      serviceDispatch(initServiceReducer(categories));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initServices]);

  useEffect(() => {
    if (initServices) {
      const oldCategories = serviceTable.sortCategoryStart?.startList ? serviceTable?.sortCategoryStart.startList : startList
      serviceDispatch(updateCategoriesList(categories, oldCategories));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]);

  useEffect(() => {
    if (initServices) {
      serviceDispatch(updateList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, searchOption, filters, startList, highlightServices, highlightCategories, servicesChecked]);

  /**
   * Clear highlights
   */
  useEffect(() => {
    if (highlightServices.length || highlightCategories.length) {
      setTimeout(() => {
        serviceDispatch(clearHighlights());
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [highlightServices, highlightCategories]);

  /**
   * Clear scroll to Category / Service
   */
  useEffect(() => {
    if (scrollToCategoryId || scrollToServiceId) {
      setTimeout(() => {
        serviceDispatch(clearScrolls());
      }, 300);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollToCategoryId, scrollToServiceId]);

  const onClickDeletedServices = () => {
    history.push('/services/deleted');
  };

  if (!initServices) {
    return <Loader />;
  }

  return (
    <div className="service-table">
      <ServiceLoader isFetching={isFetching} />
      <ServicesHeader serviceDispatch={serviceDispatch} search={serviceTable.search} searchOptionSelected={serviceTable.searchOption} />
      <ServicesBody config={config} servicesChecked={servicesChecked} serviceTable={serviceTable} serviceDispatch={serviceDispatch} />
      <ServiceModals
        modal={serviceTable.modal}
        servicesCount={serviceTable.listCount}
        servicesList={serviceTable.list}
        serviceDispatch={serviceDispatch}
      />
      {config?.deleted_services && config?.access?.restore_services ? (
        <Grid fluid>
          <div className="service-table__footer">
            <Button onClick={onClickDeletedServices} type="button" bsStyle="link">
              Deleted services
            </Button>
          </div>
        </Grid>
      ) : null}
    </div>
  );
};

export default Services;
